import compact from 'lodash/compact';
import { relationshipModel } from "../../models";
export let PreviewState = /*#__PURE__*/function (PreviewState) {
  PreviewState["Preview"] = "preview";
  PreviewState["SetupBrand"] = "setupBrand";
  return PreviewState;
}({});
export let COBStep = /*#__PURE__*/function (COBStep) {
  COBStep["welcome"] = "welcome";
  COBStep["selectAPackage"] = "packages";
  COBStep["reviewServices"] = "services";
  COBStep["approveTerms"] = "terms";
  COBStep["accountantAccess"] = "accountant-access";
  COBStep["paymentMethod"] = "payment-method";
  COBStep["introVideo"] = "intro-video";
  COBStep["summary"] = "summary";
  COBStep["allSet"] = "all-set";
  return COBStep;
}({});
export function getStepName(step, relationship) {
  switch (step) {
    case COBStep.welcome:
      return 'Introduction';
    case COBStep.selectAPackage:
      return 'Select a Package';
    case COBStep.reviewServices:
      return relationshipModel.isInvite(relationship) ? 'Review Billing Details' : 'Review Services';
    case COBStep.approveTerms:
      return 'Review Terms';
    case COBStep.accountantAccess:
      return 'Grant Accountant Access';
    case COBStep.paymentMethod:
      return 'Add a Payment Method';
    case COBStep.summary:
      return 'Sign';
    case COBStep.allSet:
      return "You're all set!";
    case COBStep.introVideo:
      return 'Welcome video';
  }
}
export function getReachableSteps(relationship, INTRO_VIDEO) {
  const hasPaymentMethod = relationship.requirePaymentMethod || relationship.isSample;
  const hasPackages = !!relationship.serviceBundles;
  return compact([COBStep.welcome, INTRO_VIDEO && relationshipModel.hasIntroVideos(relationship) && COBStep.introVideo, hasPackages && COBStep.selectAPackage, COBStep.reviewServices, COBStep.approveTerms, hasPaymentMethod && COBStep.paymentMethod, COBStep.allSet]);
}
export let Reason = /*#__PURE__*/function (Reason) {
  Reason["PaymentMethod"] = "payment-method";
  Reason["ReviewServices"] = "services";
  Reason["SelectAPackage"] = "packages";
  Reason["ReviewerApprove"] = "reviewerApprove";
  return Reason;
}({});
export const reasonToText = {
  [Reason.PaymentMethod]: 'To approve the agreement, Please add a payment method.',
  [Reason.ReviewServices]: 'To approve the agreement, It is required to select at least one service.',
  [Reason.SelectAPackage]: 'To approve the agreement, Please select a package.',
  [Reason.ReviewerApprove]: 'You can view and interact with the proposal, but not approve it.'
};
export const getNextStepButtonText = function getNextStepButtonText(step, relationship) {
  let INTRO_VIDEO = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const reachableSteps = getReachableSteps(relationship, INTRO_VIDEO);
  const currentStepIndex = reachableSteps.indexOf(step);
  if (currentStepIndex === -1) {
    throw new Error('Unreachable step');
  }
  const nextStep = reachableSteps[currentStepIndex + 1];
  if (!nextStep) {
    throw new Error('should have next step');
  }
  if (nextStep === COBStep.selectAPackage) {
    return 'Select a Package';
  }
  if (nextStep === COBStep.paymentMethod) {
    return 'Add payment method';
  }
  switch (step) {
    case COBStep.welcome:
      return relationship.isSample ? 'Review test agreement' : 'Review the agreement';
    default:
      return 'Next';
  }
};